module.exports = __webpack_public_path__ + "img/14.bb2aaa2b.jpg";